import { render } from "./PurchaseOrders.vue?vue&type=template&id=da9d2d46&scoped=true"
import script from "./PurchaseOrders.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrders.vue?vue&type=script&lang=ts"

import "./PurchaseOrders.vue?vue&type=style&index=0&id=da9d2d46&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-da9d2d46"

export default script